export default "/images/6d8e6bca07ee9cd32724147d82238433.avif";